import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const LoccitaneClose = (props: IconProps) => (
  <Icon width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="15" cy="15" r="14" fill="white" />
    <path
      d="M15 29C22.7 29 29 22.7 29 15C29 7.3 22.7 1 15 1C7.3 1 1 7.3 1 15C1 22.7 7.3 29 15 29Z"
      fill="white"
      stroke="#CCCCCC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11.0378 18.9611L18.9619 11.0371" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.9619 18.9611L11.0378 11.0371" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Icon>
);
